(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-home"]) return;
  try {
    
(function () {
  const format = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  let timer;
  function update() {
    clearTimeout(timer);
    const now = new Date();
    document.querySelectorAll('[data-pb-sicily-clock]').forEach(function (clock) {
      clock.textContent = format.format(now);
      clock.dateTime = now.toISOString();
      clock.setAttribute('aria-label', format.format(now) + ' in Trapani, Sicily');
    });
    if (!document.hidden) timer = setTimeout(update, 1000 - (Date.now() % 1000) + 50);
  }
  update();
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('pagehide', function () { clearTimeout(timer); });
})();

  } catch(e) { console.error(e); }
})();
})();
